import { render } from "./Forms.vue?vue&type=template&id=ad361ec4&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ad361ec4"

export default script